import { initializeApp } from "firebase/app";
// Import the functions you need from the SDKs you need
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore/lite";
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDbgLWZSfa3e2uoyii8HRynMYbWSkPbUOw",
  authDomain: "shoplist-ce037.firebaseapp.com",
  projectId: "shoplist-ce037",
  storageBucket: "shoplist-ce037.appspot.com",
  messagingSenderId: "801731327911",
  appId: "1:801731327911:web:7b7069b210faaa2b0e2882",
  measurementId: "G-09ZX8644VM",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export {
  app,
  auth,
  db,
};
